import * as React from 'react'
import { Chip } from '@material-ui/core'
import { mainTheme } from '../../utils/mainTheme'
import { valueInCentsToBRL } from '../../utils/utils'

interface CouponTypeChipProps {
  type: 'percentage' | 'fixed' | 'fixedPrice'
  value: number
}

const CouponTypeChip: React.FC<CouponTypeChipProps> = ({ type, value }) => {
  const getTypeConfig = (type: string) => {
    switch (type) {
      case 'percentage':
        return {
          label: 'Porcentagem',
          backgroundColor: mainTheme.palette.secondary.main,
          color: mainTheme.palette.primary.contrastText,
        }
      case 'fixed':
        return {
          label: 'Valor Fixo',
          backgroundColor: mainTheme.palette.secondary.main,
          color: mainTheme.palette.primary.contrastText,
        }
      case 'fixedPrice':
        return {
          label: 'Preço Fixo',
          backgroundColor: mainTheme.palette.secondary.main,
          color: mainTheme.palette.primary.contrastText,
        }
      default:
        return {
          label: 'Desconhecido',
          backgroundColor: mainTheme.palette.grey[400],
          color: mainTheme.palette.primary.contrastText,
        }
    }
  }

  const formatValue = (type: string, value: number) => {
    if (type === 'percentage') {
      return `${value}%`
    } else if (type === 'fixed' || type === 'fixedPrice') {
      return valueInCentsToBRL(value)
    }
    return ''
  }

  const config = getTypeConfig(type)
  const formattedValue = formatValue(type, value)

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        alignItems: 'center',
      }}
    >
      <Chip
        label={config.label}
        size="small"
        style={{
          color: config.color,
          backgroundColor: config.backgroundColor,
          fontWeight: 500,
          fontSize: '0.7rem',
          height: '20px',
        }}
      />
      <span
        style={{
          fontSize: '0.8rem',
          fontWeight: 700,
          color: mainTheme.palette.text.primary,
          textAlign: 'center',
        }}
      >
        {formattedValue}
      </span>
    </div>
  )
}

export default CouponTypeChip
